/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Feature_BookingInputs */

const en_price_page_app_feature_booking = /** @type {(inputs: Price_Page_App_Feature_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always free: bookings, reminders and your coach's plan`)
};

const pl_price_page_app_feature_booking = /** @type {(inputs: Price_Page_App_Feature_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawsze za darmo: rezerwacje, przypomnienia i plan od trenera`)
};

/**
* | output |
* | --- |
* | "Always free: bookings, reminders and your coach's plan" |
*
* @param {Price_Page_App_Feature_BookingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_feature_booking = /** @type {((inputs?: Price_Page_App_Feature_BookingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Feature_BookingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_feature_booking(inputs)
	return en_price_page_app_feature_booking(inputs)
});